import script from "./item_service_group.vue?vue&type=script&setup=true&lang=js"
export * from "./item_service_group.vue?vue&type=script&setup=true&lang=js"

import "./item_service_group.vue?vue&type=style&index=0&id=085318f9&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085318f9"]])

export default __exports__